import React from 'react';
//import classes from './Layout.css';
const footer = ( props ) => (
    <footer className="footer">
    © Copyright {new Date().getFullYear()} S3A Manufacturing. All Rights Reserved.
</footer>
);

export default footer;
